import MainLayout, { PermissionRoute } from 'layouts/MainLayout';
import { RouteObject, createBrowserRouter } from 'react-router-dom';

// import Ecommerce from 'pages/dashboard/ecommerce';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import App from 'App';

import Error404 from 'pages/error/Error404';
import Error403 from 'pages/error/Error403';
import Error500 from 'pages/error/Error500';

import SimpleSignIn from 'pages/pages/authentication/simple/SignIn';
import SimpleSignUp from 'pages/pages/authentication/simple/SignUp';
import SimpleSignOut from 'pages/pages/authentication/simple/SignOut';
import SimpleResetPassword from 'pages/pages/authentication/simple/ResetPassword';
import SimpleLockScreen from 'pages/pages/authentication/simple/LockScreen';
import SimpleTwoFA from 'pages/pages/authentication/simple/TwoFA';
import SimpleForgotPassword from 'pages/pages/authentication/simple/ForgotPassword';

import Homepage from 'pages/dashboard/homepage';

import Calendario from 'pages/apps/calendar/Calendar';

import PendingTable from 'pages/apps/carmanagment/TablePending';
import FinalizedTable from 'pages/apps/carmanagment/TableFinalized';
import AlocationTable from 'pages/apps/carmanagment/adminside/Tablealocation';
import CarStateManagement from 'pages/apps/carmanagment/adminside/CarStateManagement';
import CarDetails from 'pages/apps/carmanagment/adminside/CarDetails';
import TripManagement from 'pages/apps/carmanagment/userSide/TripManagement';

import FinanceMainPage from 'pages/apps/PowerBIPages/financeManagement';
import LabMainPage from 'pages/apps/PowerBIPages/labManagement';
import CalendarMainPage from 'pages/apps/PowerBIPages/calendarManagement';
import CalendarAdminMainPage from 'pages/apps/PowerBIPages/calendarAdminManagement';

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: <SimpleSignIn /> // Direct route to login without layout
      },
      {
        path: '/viagens/',
        element: (
          <MainLayoutProvider>
            <MainLayout />
          </MainLayoutProvider>
        ),
        children: [
          {
            index: true,
            element: (
              <PermissionRoute
                moduleId={1}
                submoduleId={3}
                requiredPermission={1}
              >
                <TripManagement />
              </PermissionRoute>
            )
          },
          {
            path: ':guidCarro',
            element: (
              <PermissionRoute
                moduleId={1}
                submoduleId={3}
                requiredPermission={1}
              >
                <TripManagement />
              </PermissionRoute>
            )
          }
        ]
      },
      {
        path: '/dashboard',
        element: (
          <MainLayoutProvider>
            <MainLayout />
          </MainLayoutProvider>
        ),
        children: [
          {
            index: true,
            // element: <Calendario /> // Change for some other page
            element: (
              <PermissionRoute moduleId={1} requiredPermission={1}>
                <Homepage />
              </PermissionRoute>
            ) // Change for some other page
          },
          {
            path: 'calendar',
            children: [
              {
                path: 'personalCalendar',
                element: <Calendario />
              }
            ]
          },
          {
            path: 'carManagement',
            children: [
              {
                path: 'pendingTable',
                element: (
                  <PermissionRoute
                    moduleId={1}
                    submoduleId={1}
                    requiredPermission={1}
                  >
                    <PendingTable />
                  </PermissionRoute>
                )
              },
              {
                path: 'finalizedTable',
                element: (
                  <PermissionRoute
                    moduleId={1}
                    submoduleId={2}
                    requiredPermission={1}
                  >
                    <FinalizedTable />
                  </PermissionRoute>
                )
              },
              {
                path: 'alocationTable',
                element: (
                  <PermissionRoute
                    moduleId={1}
                    submoduleId={4}
                    requiredPermission={1}
                  >
                    <AlocationTable />
                  </PermissionRoute>
                )
              },
              {
                path: 'carstatemanagement',
                element: (
                  <PermissionRoute
                    moduleId={1}
                    submoduleId={5}
                    requiredPermission={1}
                  >
                    <CarStateManagement />
                  </PermissionRoute>
                )
              },
              {
                path: 'cardetails/:guidCarro',
                element: (
                  <PermissionRoute
                    moduleId={1}
                    submoduleId={5}
                    requiredPermission={1}
                  >
                    <CarDetails />
                  </PermissionRoute>
                )
              },
              {
                path: 'tripmanagement/:guidCarro',
                element: (
                  <PermissionRoute
                    moduleId={1}
                    submoduleId={3}
                    requiredPermission={1}
                  >
                    <TripManagement />
                  </PermissionRoute>
                )
              }
            ]
          },
          {
            path: 'StatsManagement',
            children: [
              {
                path: 'powerBiTableVendas',
                element: (
                  <PermissionRoute
                    moduleId={7}
                    submoduleId={2}
                    requiredPermission={1}
                  >
                    <FinanceMainPage />
                  </PermissionRoute>
                )
              },
              {
                path: 'powerBiTableLaboratorio',
                element: (
                  <PermissionRoute
                    moduleId={7}
                    submoduleId={3}
                    requiredPermission={1}
                  >
                    <LabMainPage />
                  </PermissionRoute>
                )
              },
              {
                path: 'powerBiTableCalendar',
                element: (
                  <PermissionRoute
                    moduleId={7}
                    submoduleId={1}
                    requiredPermission={1}
                  >
                    <CalendarMainPage />
                  </PermissionRoute>
                )
              },
              {
                path: 'powerBiTableAdminCalendar',
                element: (
                  <PermissionRoute
                    moduleId={7}
                    submoduleId={4}
                    requiredPermission={1}
                  >
                    <CalendarAdminMainPage />
                  </PermissionRoute>
                )
              }
            ]
          }
        ]
      },
      {
        path: '/pages/errors/',
        children: [
          {
            path: '404',
            element: <Error404 />
          },
          {
            path: '403',
            element: <Error403 />
          },
          {
            path: '500',
            element: <Error500 />
          }
        ]
      },
      {
        path: '/pages/authentication/simple/',
        children: [
          {
            path: 'sign-in',
            element: <SimpleSignIn />
          },
          {
            path: 'sign-up',
            element: <SimpleSignUp />
          },
          {
            path: 'sign-out',
            element: <SimpleSignOut />
          },
          {
            path: 'forgot-password',
            element: <SimpleForgotPassword />
          },
          {
            path: 'reset-password',
            element: <SimpleResetPassword />
          },
          {
            path: 'lock-screen',
            element: <SimpleLockScreen />
          },
          {
            path: '2FA',
            element: <SimpleTwoFA />
          }
        ]
      },
      {
        path: '*',
        element: <Error404 />
      }
    ]
  }
];

export const router = createBrowserRouter(routes);

export default routes;
